import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { H3, Paragraph } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import { Link } from 'components/core/Link';
import { Container, Section } from 'components/core/Page';
import { generateStars } from 'utils/formatting';
import ReviewCard from '../ReviewCard/ReviewCard';
import TrustPilotReviews from './TrustPilotReviews';

import trustpilotStar from 'assets/images/landing/trustpilot-star.svg';
import trustpilotType from 'assets/images/landing/trustpilot-type.svg';

import './TrustPilotReviewSectionV2.scss';

export default function TrustPilotReviewSection({
	// TODO: Swap TrustPilotReviewsV2 with TrustPilotReviewsV1 when sf_15731_plp_refactor_ssdc is a winner
	className,
	reviews = TrustPilotReviews,
}) {
	return (
		<Section
			className={classnames(className, 'reviews-section')}
			id="reviews-section"
		>
			<Container>
				<div className="star-container">
					{generateStars(4.5, '20', '20', 'white')}
				</div>
				<span className="nowrap-logo">
					<H3
						color="white"
						size="megaMobile"
					>
						Rated 4.4 out of 5 stars by our customers on
						<span className="trust-pilot-logo">
							<Image
								src={trustpilotStar}
								alt="trust-pilot-star"
							/>
							<Image
								src={trustpilotType}
								alt="trust-pilot-text"
							/>
						</span>
					</H3>
				</span>
				{reviews && (
					<div className="reviews-list">
						{reviews.map((card) => (
							<ReviewCard
								title={card.title}
								stars={card.stars}
								description={card.text}
								user={card.customerName}
								key={card.customerName}
								customerImage={card.customerImage}
							/>
						))}
					</div>
				)}
				<div className="reviews-footer">
					<Link
						tertiary
						underline
						color="white"
						href="https://www.trustpilot.com/review/www.selfstorage.com"
						target="_blank"
					>
						See more reviews on TrustPilot
					</Link>
					<Paragraph
						color="white"
						size="tiny"
						weight="standard"
					>
						Reviews shared by genuine SelfStorage.com customers. The
						images used are stock photos and do not depict the
						actual individuals who provided the reviews.
					</Paragraph>
				</div>
			</Container>
		</Section>
	);
}

TrustPilotReviewSection.propTypes = {
	reviews: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			stars: PropTypes.number,
			text: PropTypes.string,
			customerName: PropTypes.string,
			reviewDate: PropTypes.string,
			className: PropTypes.string,
		}),
	),
	className: PropTypes.string,
};
